import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-main-authentication',
    templateUrl: './main-authentication.component.html',
    styleUrls: ['./main-authentication.component.scss']
})
export class MainAuthenticationComponent implements OnInit {

    public urlLogo: string = 'assets/images/logos/logo-comillas.png';
    public activeRoute: string;

    constructor(private router: Router) {

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.activeRoute = event.url;
            }
        });

    }

    ngOnInit() { }

}
